export default "__VITE_ASSET__b74c736c__"